/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginInput } from '../models/LoginInput';
import type { LoginResultDto } from '../models/LoginResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * @param redirectUrl
     * @param clientId
     * @param codeChallenge
     * @returns any Success
     * @throws ApiError
     */
    public static authorize(
        redirectUrl?: string,
        clientId?: string,
        codeChallenge?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Auth/Authorize',
            query: {
                'redirect_url': redirectUrl,
                'client_id': clientId,
                'code_challenge': codeChallenge,
            },
        });
    }
    /**
     * @param requestBody
     * @returns LoginResultDto Success
     * @throws ApiError
     */
    public static login(
        requestBody?: LoginInput,
    ): CancelablePromise<LoginResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/Auth/Login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param redirectUrl
     * @returns any Success
     * @throws ApiError
     */
    public static logout(
        redirectUrl?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Auth/Logout',
            query: {
                'redirect_url': redirectUrl,
            },
        });
    }
}
